import { Store } from 'redux';
import { RouterState, RedirectFunction } from 'react-router';

import { GlobalState } from 'ha/types/store';
import { getInfo } from 'ha/modules/Hermes';
import formatCountryUrl from 'ha/utils/urls/formatCountryUrl';

const onEnterCountry = (store: Store<GlobalState>) => (
  { location, params }: RouterState,
  replace: RedirectFunction,
) => {
  const info = getInfo(store.getState());

  if (!info) {
    return;
  }

  const correctPathname = formatCountryUrl(
    info.path,
    params.category?.toLowerCase(),
  );

  if (decodeURIComponent(location.pathname) !== correctPathname) {
    replace({
      ...location,
      pathname: correctPathname,
    });
  }
};

export default onEnterCountry;
